// Tag for graphql format
const gql = String.raw;

const getOnCreateAssignment = () => gql`
	subscription MySubscription {
		onCreatePayPlanAssignment {
			users {
				upcomingPayPlanAssignment {
					acknowledgementDate
					assignmentDate
					planId {
						_id
						name
					}
				}
				_id
			}
		}
	}
`;

const getOnRemoveUser = () => gql`
	subscription MySubscription {
		onRemoveUserPayPlanAssignment {
			_id
		}
	}
`;

const getAssignmentsSubscriptions = () => [
	{
		context: "onCreatePayPlanAssignment",
		query: getOnCreateAssignment(),
	},
	{
		context: "onRemoveUserPayPlanAssignment",
		query: getOnRemoveUser(),
	},
];

export { getAssignmentsSubscriptions, getOnCreateAssignment, getOnRemoveUser };
